export default __webpack_public_path__ + "static/media/stonewalls2.22574ba1.png";